import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { FileQuestion } from 'lucide-react';
import { buildMarketingUrl } from '@/lib/workspace';

interface WorkspaceNotFoundPageProps {
  slug: string;
}

export function WorkspaceNotFoundPage({ slug }: WorkspaceNotFoundPageProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="flex justify-center mb-4">
            <FileQuestion className="h-12 w-12 text-muted-foreground" />
          </div>
          <CardTitle className="text-2xl">Workspace not found</CardTitle>
          <CardDescription>
            We couldn't find a workspace at <strong>{slug}</strong>.icrop.net. Check the spelling
            or contact the workspace owner.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild>
            <a href={buildMarketingUrl()}>Go to iCrop.net</a>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
